import listFlowReducer, { ListFlowState } from '@sls-react/store/listFlow/ui';
import { combineReducers } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

// TODO: Type inferencing wasn't working on root state, so I had to add it here.
export interface RootState {
  listFlow: ListFlowState;
}

const rootReducer = combineReducers({
  listFlow: listFlowReducer,
});

function principalReducer(state: any, action: any) {
  if (action?.type === HYDRATE) {
    return { ...state, ...action.payload };
  }

  return rootReducer(state, action);
}

export default principalReducer;
